import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { User, Users } from 'lucide-react';

interface IntentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onIndividualSelect: () => void;
  onBusinessSelect: () => void;
}

const IntentModal: React.FC<IntentModalProps> = ({
  isOpen,
  onClose,
  onIndividualSelect,
  onBusinessSelect,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>How will you use Zentrix?</DialogTitle>
          <DialogDescription>
            Are you exploring for yourself or bringing this to your team?
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button
            onClick={onIndividualSelect}
            size="lg"
            className="flex items-center justify-center gap-2 h-16"
            variant="default"
          >
            <User className="h-5 w-5" />
            <span>For Myself</span>
          </Button>
          <Button
            onClick={onBusinessSelect}
            size="lg"
            className="flex items-center justify-center gap-2 h-16"
            variant="outline"
          >
            <Users className="h-5 w-5" />
            <span>For My Team</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default IntentModal;
